"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = __importDefault(require("./colors"));
var LL_BRAND_UTILS = {
    base_border_width: '2px',
    base_border_style: "2px solid ".concat(colors_1.default.border_color),
    active_border_style: "2px solid ".concat(colors_1.default.interactive),
};
var LL_MOBILE_UTILS = {
    borderWidth: 2,
    base_mobile_border_style: {
        borderWidth: 2,
        borderColor: colors_1.default.border_color,
    },
    active_mobile_border_style: {
        borderWidth: 2,
        borderColor: colors_1.default.border_color,
    },
};
exports.default = __assign(__assign({}, LL_BRAND_UTILS), LL_MOBILE_UTILS);
